"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var TeamSelectFilterActions = require("../actions/team-select-filter-actions.js");

var UserSelectFilterStore = Reflux.createStore({
  state: {
    teams: []
  },
  setState: function(state){
    this.state = state;
    this.trigger(this.state);
    return this.state;
  },
  getInitialState: function() {
    return {
      teams: []
    };
  },
  init: function(){
    this.listenTo(TeamSelectFilterActions.loadTeams.completed, this.onLoadTeamsCompleted);
    this.state = this.getInitialState();
  },
  onLoadTeamsCompleted: function(teams){
    this.state.teams = teams;
    this.trigger(this.state);
  },
});

module.exports = UserSelectFilterStore;



// WEBPACK FOOTER //
// ./app/shared/stores/team-select-filter-store.js